import { TaskStatus } from 'app/console-api';
import styled, { useTheme } from 'styled-components';
import { BoldText } from 'app/components/common/table/styled-elements';
import React from 'react';
import { TasksStatusesMeta } from 'app/components/common/tasks-statuses/tasks-statuses';
import { StyledChipsTag } from 'app/components/common/common-styles';

export const StyledStatusDot = styled.div<{ color: string }>(({ theme, color }) =>
  theme.withMedia({
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: color,
    margin: '8px 4px'
  })
);

interface TasksStatusChipsProps {
  status: TaskStatus;
  isActive: boolean;
}

export const TasksStatusChips = ({ status, isActive }: TasksStatusChipsProps) => {
  const theme = useTheme();
  const meta = isActive ? TasksStatusesMeta[status] : TasksStatusesMeta[TaskStatus.Inactive];
  return (
    <StyledChipsTag color={meta.getColor(theme)}>
      <StyledStatusDot color={meta.getColor(theme)} />
      <BoldText size={4} scale={'xs'}>
        {meta.title}
      </BoldText>
    </StyledChipsTag>
  );
};
